import {Component, HostBinding, Input, OnChanges, Signal, SimpleChanges} from '@angular/core';
import {File, Folder} from '../../types-repository';
import {UserProfileService} from '../../services/user-profile.service';


@Component({
  selector: 'app-s3-link',
  templateUrl: './s3-link.component.html',
  styleUrls: ['./s3-link.component.scss']
})
export class S3LinkComponent implements OnChanges {

  _fof: File | Folder;
  link: string;

  deepLink: Signal<boolean>;

  @HostBinding('hidden')
  get hidden() {
    return !this.deepLink();
  }

  @Input()
  set fof(fof: string | File | Folder) {
    if (fof) {
      if (typeof fof === 'string') {
        if (fof.endsWith('/')) {
          this._fof = {id: fof} as Folder
        } else {
          this._fof = {id: fof} as File
        }
      } else {
        this._fof = fof;
      }
    }
  }


  constructor(userProfileService: UserProfileService) {
    this.deepLink = userProfileService.staff
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this._fof) {
      const sp = this._fof.id.split('/')
      this.link = `https://s3.console.aws.amazon.com/s3/buckets/${sp[2]}?region=us-east-1&prefix=${sp.slice(3, -1).join('/')}/&showversions=true`
    }
  }
}
